import React from 'react';
import { useState, useRef } from 'react';
import { VStack, HStack, Heading, Flex, Box, Button, Text, Link } from '@chakra-ui/react';
import { Form, Formik } from 'formik';
import * as Yup from 'yup';
import CustomFormInput from "../components/FormInputFields";
import axios from 'axios';
import CommonVars from "../components/CommonVars";

function SignUp() {
    const errRef = useRef();
    const successRef = useRef();
    const [errMsg, setErrMsg] = useState('');
    const [successMsg, setSuccessMsg] = useState('');
    return (
        <Formik
            initialValues={{
                username: '',
                fullname: '',
                email: '',
                password: '',
                cfmPassword: '',
            }}
            validationSchema={Yup.object({
                username: Yup.string()
                .min(4, 'Username must be at least 4 characters long')
                .required('Username is required'),
                fullname: Yup.string()
                .required('Please enter your first name'),
                email: Yup.string()
                .email('Invalid Email Address')
                .required('Email is required'),
                password: Yup.string()
                .min(8, 'Password is too short - should be 8 characters minimum.')
                .matches(/^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d]{8,}$/, 'Minimum eight characters, with at least one letter and one number')
                .required('Password is required'),
                cfmPassword: Yup.string()
                .oneOf([Yup.ref('password'), null], 'Password and Confirm Password does not match')
                .required('Confirm Password is required')
            })}
            onSubmit={(values, { setSubmitting, resetForm }) => {
                const requestBody = values;
                axios.post(`${CommonVars.API_URL}/users/`, requestBody)
                .then((response) => {
                    console.log(response);
                    setSuccessMsg('New account registered successfully!');
                    resetForm();
                    setSubmitting(false);
                    setTimeout(() => {
                        window.location.href = '/login'
                    }, 2000)
                    
                })
                .catch((error) => {
                    if (error.response?.status === 422) {
                        setErrMsg('Username or Email is Taken.');
                        setTimeout(() => {
                            setErrMsg();
                            console.clear();
                        }, 3000)
                    }
                    setSubmitting(false);
                })
            }}
        >
            {props => (
                <Flex bg="#F4F4F4" align="center" justify="center" h="115vh">
                    <Box bg="white" w='60%' p={19} rounded="lg" shadow='md'>
                        <Form>
                            <Heading pl={7} pt={8}>Sign Up</Heading>
                            <Text py={4} pl={7}>Have an account? <Link href='/login' color={'blue.400'}>Login</Link></Text>
                            <VStack align="stretch" spacing='7px' px={7}>
                                <p ref={errRef} className={errMsg ? "errmsg" : "offscreen"}>{errMsg}</p>
                                <p ref={successRef} className={successMsg ? "successmsg" : "offscreen"}>{successMsg}</p>
                                <CustomFormInput
                                    label="Username" 
                                    name="username" 
                                    type="text"
                                    placeholder="Enter Username"
                                />
                                <CustomFormInput
                                    label="Full Name" 
                                    name="fullname" 
                                    type="text"
                                    placeholder="Enter Full Name"
                                />
                                <CustomFormInput
                                    label="Email" 
                                    name="email" 
                                    type="text"
                                    placeholder="Enter Email Address"
                                />
                                <CustomFormInput
                                    label="Password" 
                                    name="password" 
                                    type="password"
                                    placeholder="Enter Password"
                                />
                                <CustomFormInput
                                    label="Confirm Password" 
                                    name="cfmPassword" 
                                    type="password"
                                    placeholder="Confirm Password"
                                />
                            </VStack>
                            <HStack spacing='20px' pt={8} pb={2} pl={7}>
                                <Button type='submit' bg={'black'} color={'white'} _hover={{bg: '#37404A',}}>{props.isSubmitting ? 'Loading...' : 'Submit'}</Button>
                                <Button type='reset'>Reset</Button>
                            </HStack>
                        </Form>
                    </Box>
                </Flex>
            )}
        </Formik>
    )
}

export default SignUp;